'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Common', 'App');

function mapStateToProps(state) {
    return {
        deliveryAddresses: state.customer.contact.deliveryAddresses,
        deliveryAddressId: state.customer.contact.deliveryAddressId
    };
}

var DeliveryAddress = (_dec = (0, _reactRedux.connect)(mapStateToProps), _dec(_class = (_temp = _class2 = function (_React$PureComponent) {
    (0, _inherits3.default)(DeliveryAddress, _React$PureComponent);

    function DeliveryAddress() {
        (0, _classCallCheck3.default)(this, DeliveryAddress);
        return (0, _possibleConstructorReturn3.default)(this, (DeliveryAddress.__proto__ || (0, _getPrototypeOf2.default)(DeliveryAddress)).apply(this, arguments));
    }

    (0, _createClass3.default)(DeliveryAddress, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                deliveryAddresses = _props.deliveryAddresses,
                deliveryAddressId = _props.deliveryAddressId;

            var _ref = (deliveryAddresses || []).find(function (x) {
                return x.id === deliveryAddressId;
            }) || {},
                contactPerson = _ref.contactPerson,
                street = _ref.street,
                city = _ref.city,
                postCode = _ref.postCode,
                countryName = _ref.countryName;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'h3',
                    null,
                    Resx.App.DeliveryAddress,
                    ':'
                ),
                !deliveryAddressId && _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    _react2.default.createElement(
                        'div',
                        { className: 'col-6' },
                        Resx.App.SameAsDeliveryAddress
                    )
                ),
                !!deliveryAddressId && _react2.default.createElement(
                    'div',
                    { className: 'row form__address-list' },
                    contactPerson && _react2.default.createElement(
                        'div',
                        { className: 'form__input col-sm-6' },
                        _react2.default.createElement(
                            'div',
                            { className: 'input input--static input--filled' },
                            _react2.default.createElement(
                                'span',
                                null,
                                contactPerson
                            )
                        ),
                        _react2.default.createElement(
                            'label',
                            null,
                            Resx.Common.FullName
                        )
                    ),
                    street && _react2.default.createElement(
                        'div',
                        { className: 'form__input col-sm-6' },
                        _react2.default.createElement(
                            'div',
                            { className: 'input input--static input--filled' },
                            _react2.default.createElement(
                                'span',
                                null,
                                street
                            )
                        ),
                        _react2.default.createElement(
                            'label',
                            null,
                            Resx.Common.Street
                        )
                    ),
                    city && _react2.default.createElement(
                        'div',
                        { className: 'form__input col-sm-6' },
                        _react2.default.createElement(
                            'div',
                            { className: 'input input--static input--filled' },
                            _react2.default.createElement(
                                'span',
                                null,
                                city
                            )
                        ),
                        _react2.default.createElement(
                            'label',
                            null,
                            Resx.Common.City
                        )
                    ),
                    postCode && _react2.default.createElement(
                        'div',
                        { className: 'form__input col-sm-6' },
                        _react2.default.createElement(
                            'div',
                            { className: 'input input--static input--filled' },
                            _react2.default.createElement(
                                'span',
                                null,
                                postCode
                            )
                        ),
                        _react2.default.createElement(
                            'label',
                            null,
                            Resx.Common.PostCode
                        )
                    ),
                    countryName && _react2.default.createElement(
                        'div',
                        { className: 'form__input col-sm-6' },
                        _react2.default.createElement(
                            'div',
                            { className: 'input input--static input--filled' },
                            _react2.default.createElement(
                                'span',
                                null,
                                countryName
                            )
                        ),
                        _react2.default.createElement(
                            'label',
                            null,
                            Resx.Common.Country
                        )
                    )
                )
            );
        }
    }]);
    return DeliveryAddress;
}(_react2.default.PureComponent), _class2.propTypes = {
    deliveryAddressId: _propTypes2.default.number,
    deliveryAddresses: _propTypes2.default.array
}, _temp)) || _class);
exports.default = DeliveryAddress;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/step4/DeliveryAddress.js
// module id = 1143
// module chunks = 0